import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { PublisherView, getPublisherOptions } from '@/module/Publisher';

export const Route = createFileRoute('/_auth/publisher/_publisher/$publisherId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { publisherId } = Route.useParams();
  const { data: publisher } = useSuspenseQuery(getPublisherOptions(publisherId));

  return <PublisherView publisher={publisher} />;
}
